"use client";

// Activity tab for the admin-user registry detail modal.
// Split out of AdminUserDetailTabComponents.tsx (module-size).

import { formatCentralDate } from "@/components/admin/users/UserDetailModal/user-detail-utils";
import { Field, type AdminUserTabProps } from "./AdminUserFields";

export function AdminUserActivityDisplay({ item: user }: AdminUserTabProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Field label="Account created">{formatCentralDate(user.created_at)}</Field>
      <Field label="Last updated">{formatCentralDate(user.updated_at)}</Field>
      <div className="sm:col-span-2 text-xs text-muted-foreground pt-1">
        Detailed activity history isn&apos;t tracked for users yet. Account
        timestamps are shown above.
      </div>
    </div>
  );
}
